import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {useEffect, useRef, useState} from "react";
import axiApi from "ApiCaller";
import TableChoiceGroup from "./TableChoiseGroup";
import ModalCreateGroup from "./ModalCreateGroup";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import TableCheckboxGroup from "./TableCheckboxGroup";


const ModalGroup = (
    {
        showModalGroup, setShowModalGroup,
        multiple = false, create = true, chosenIn = [], subtitle=""
    }) => {
    const [item, setItem] = useState({})
    const items = useRef({
        all: [],
        showed: [],
        chosen: [],
        checked: []
    })
    const [itemsShow, setItemsShow] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [checked, setChecked] = useState([]);
    useEffect(() => {
        axiApi.get(`/api/assets/groups/`).then((resp) => {
            items.current.all = [...resp.data.items];
            items.current.showed = [...resp.data.items];
            setItemsShow([...resp.data.items]);
        });
    }, []);

    useEffect(() => {
        if (chosenIn.length) {
            items.current.checked = chosenIn.map(it => it.id);
            setChecked([...items.current.checked]);
            setItemsShow([...items.current.all]);
        }
    }, [chosenIn])





    const onSearch = (event) => {
        let items_ = items.current.all.filter(it => items.current.checked.includes(it.id));
        const valueSearched = toLowCaseCleanSpaces(event.target.value);
        if (valueSearched) {
            let filter_ = items.current.all.filter(
                (_item) => toLowCaseCleanSpaces(_item.name).includes(valueSearched)
                    && !items.current.checked.includes(_item.id)
            )
            items.current.showed = [...items_, ...filter_];
        } else {
            items.current.showed = [...items.current.all];
        }
        setItemsShow([...items.current.showed]);
    };


    const handleClose = () => {
        setShowModalGroup(false);
    }
    const handleAccept = () => {
        setShowModalGroup(false);

        if (multiple) {
            let items_ = items.current.all.filter(item => items.current.checked.includes(item.id));
            document.dispatchEvent(new CustomEvent("groupasset:modalselect:change", {detail: items_}))
        } else {
            document.dispatchEvent(new CustomEvent("groupasset:modalselect:change", {detail: item}))
        }
        items.current.showed = [...items.current.all];
        setItemsShow([...items.current.showed]);
    }

    const openFormCreateGroup = () => {
        setShowForm(true);
    }

    return (

        <>

            {create && showForm ?
                <ModalCreateGroup
                    showForm={showForm}
                    setShowForm={setShowForm}
                    items={items}
                    setItemsShow={setItemsShow}
                />
                : <> </>}
            <Modal show={showModalGroup} onHide={handleClose} animation={true}>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="object-group"/>
                    </div>
                    <div className="preview-title d-inline-flex align-items-center">
                        <Modal.Title className="d-inline-flex ms-1">
                            <div>
                                <div className="h4 ms-0">
                                    Grupos
                                </div>
                                <div className="h5 ms-0">
                                    <small>{subtitle}</small>
                                </div>
                            </div>
                        </Modal.Title>
                        {
                            create
                                ? <button className="btn btn-primary ms-5" onClick={openFormCreateGroup}>
                                    <FontAwesomeIcon icon="fa-plus"/>
                                </button>
                                : <></>
                        }
                        <form className="d-inline-flex ms-2" role="search">
                            <input className="form-control border-end-0 rounded-0" type="search"
                                   placeholder="Nombre"
                                   aria-label="Search"
                                   onChange={onSearch}
                            />
                            <span className="input-group-text bg-white border-start-0 rounded-0"
                                  id="modal-searcher-groups">
                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass"/>
                            </span>
                        </form>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {
                        multiple
                            ? <TableCheckboxGroup
                                items={items}
                                itemsShow={itemsShow}
                                checked={checked}
                                setChecked={setChecked}
                            />
                            : <TableChoiceGroup
                                items={items}
                                itemsShow={itemsShow}
                                setItem={setItem}
                            />
                    }

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Descartar
                    </Button>
                    <Button variant="primary" onClick={handleAccept}>
                        Seleccionar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );


}

export default ModalGroup